import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import usePagination from "../hooks/usePagination";
import { useNavigate, useParams } from "react-router-dom";
import LoadingAnimation from "../components/LoadingAnimation";
import CartButton from "../components/CartButton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";


import "./CategoryProducts.css";



export default function CategoryProducts() {

  const navigate = useNavigate();
  const { category } = useParams();

 const [cartQty, setCartQty] = useState({});
const [cartItemId, setCartItemId] = useState({});
  const [cartCount, setCartCount] = useState(0);
const [updatingId, setUpdatingId] = useState(null);
  const [search, setSearch] = useState("");
  
const fetchProducts = (page) => {
  return axiosInstance.get("/consumer/by-category/", {
    params: {
      category: decodeURIComponent(category),
      page: page,
      search: search || undefined
    }
  });
};

const {
  items: products,
  loading,
  reset
} = usePagination(fetchProducts, [category, search]);

useEffect(() => {
  reset();
  loadCart();
}, [category, search]);




  // ---------------- PRODUCTS ----------------

async function increaseQty(productId) {
 // console.log("ITEM ID:", productId);
  if (updatingId === productId) return;

  const itemId = cartItemId[productId];
  if (!itemId) return; // ✅ FIX

  setUpdatingId(productId);

  setCartQty(prev => ({
    ...prev,
    [productId]: (prev[productId] || 0) + 1
  }));

  setCartCount(prev => prev + 1);

  try {
    await axiosInstance.post("/consumer-cart/update/", {
      item_id: itemId,
      action: "increase"
    });
  } finally {
    setUpdatingId(null);
  }
}

async function decreaseQty(productId) {

  if (updatingId === productId) return;

  const itemId = cartItemId[productId];

if (!itemId) {
  console.log("Missing itemId for product:", productId);
  return;
}

  const currentQty = cartQty[productId] || 0;
  if (currentQty <= 0) return;

  setUpdatingId(productId);

  // ✅ better UI remove
  if (currentQty === 1) {
    setCartQty(prev => {
      const copy = { ...prev };
      delete copy[productId];
      return copy;
    });
  } else {
    setCartQty(prev => ({
      ...prev,
      [productId]: currentQty - 1
    }));
  }

  setCartCount(prev => Math.max(0, prev - 1));

  try {

    if (currentQty === 1) {
      await axiosInstance.post("/consumer-cart/remove/", {
        item_id: itemId
      });
    } else {
      await axiosInstance.post("/consumer-cart/update/", {
        item_id: itemId,
        action: "decrease"
      });
    }

  } finally {
    setUpdatingId(null);
  }
}
  // ---------------- CART ----------------

async function loadCart() {
  try {
    const res = await axiosInstance.get("/cart/");

    const items = res.data.items || []; // ✅ FIX

    const qtyMap = {};
    const idMap = {};
    let total = 0;

 items.forEach((item) => {

  // ✅ ONLY CONSUMER CART ITEMS
  if (item.cart_type !== "consumer") return;

  const pid = item.product_id || item.product?.id;

  console.log("CONSUMER ITEM:", item);

  qtyMap[pid] = item.quantity;
  idMap[pid] = item.id;

  total += item.quantity;
});

    setCartQty(qtyMap);
    setCartItemId(idMap);
    setCartCount(total);

  } catch {
    console.log("Cart load error");
  }
}

  // ---------------- ADD ----------------
async function addToCart(productId) {

  if (updatingId === productId) return;

  setUpdatingId(productId);

  // 🔥 instant UI
  setCartQty(prev => ({
    ...prev,
    [productId]: (prev[productId] || 0) + 1
  }));

  setCartCount(prev => prev + 1);

  try {

    const res = await axiosInstance.post("/consumer-cart/add/", {
      product_id: productId,
      quantity: 1
    });

    if (res.data?.item_id) {
      setCartItemId(prev => ({
        ...prev,
        [productId]: res.data.item_id
      }));
    } else {
      // 🔥 only fallback
      await loadCart();
    }

  } catch (err) {
    console.log("Add failed", err);

    // rollback UI
    setCartQty(prev => ({
      ...prev,
      [productId]: Math.max(0, (prev[productId] || 1) - 1)
    }));

    setCartCount(prev => Math.max(0, prev - 1));

  } finally {
    setUpdatingId(null);
  }
}

  // ---------------- UPDATE ----------------


  // ---------------- HELPERS ----------------





  // ---------------- UI ----------------
// 👇 THIS LINE ADD BEFORE return(
if (loading && products.length === 0 && !search)  {
  return <LoadingAnimation />;
}
  return (
    <div style={{
  padding: 20,
  paddingTop: "calc(20px + env(safe-area-inset-top))",
  paddingBottom: "calc(90px + env(safe-area-inset-bottom))"
}}>

      {/* HEADER */}
{/* NEW HEADER */}

<div style={{
  paddingTop: "env(safe-area-inset-top)"
}}>
  <CartButton />
</div>


			








      {/* SEARCH */}
<div style={searchWrapper}>

  <input
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    placeholder="Search Products..."
    style={searchBox}
  />

</div>	




      {/* GRID */}
      <div style={gridStyle}>

        {products.map(p => {
const mrp = Number(String(p.mrp || 0).trim());
const sellingPrice = Number(String(p.selling_price || 0).trim());
const qty = cartQty[p.id] || 0;
const isUpdating = updatingId === p.id;
          

          return (

            <div key={p.id} style={card}>

              {/* NAME */}
              <div style={nameBox}>
                {p.name}
              </div>


              {/* IMAGE */}
{/* IMAGE */}
<div style={{ height: 130, textAlign: "center" }}>

  {p.images && p.images.length > 0 ? (
<PhotoProvider maskClosable={true}>
    <Swiper
      modules={[Pagination]}
      pagination={{ clickable: true }}
      spaceBetween={10}
      slidesPerView={1}
	observer={true}
  	observeParents={true}
      style={{ width: "100%", height: "100%" }}
    >

      {p.images.map((img, index) => (
        <SwiperSlide key={index}>

          
            <PhotoView src={img}>
              <img
                src={img}
                alt={p.name}
                loading="lazy"
                onError={(e) => {
                  e.target.src = "/no-image.png";
                }}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  cursor: "zoom-in",
  backfaceVisibility: "hidden",
  transform: "translateZ(0)",

                }}
              />
            </PhotoView>
         

        </SwiperSlide>
      ))}

    </Swiper>
 </PhotoProvider>
  ) : p.image ? (

    <PhotoProvider maskClosable={true}>
      <PhotoView src={p.image}>
        <img
          src={p.image || "/no-image.png"}
          loading="lazy"
          onError={(e) => {
            e.target.src = "/no-image.png";
          }}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            cursor: "zoom-in",
          }}
          alt={p.name}
        />
      </PhotoView>
    </PhotoProvider>

  ) : (

    <div style={noImg}>
      No Image
    </div>

  )}

</div>
<div
  style={{
    fontSize: 11,
    color: "#777",
    textAlign: "center",
    marginTop: 4,
  }}
>
  Tap image to zoom • Tap outside to close
</div>

              {/* PRICE */}
             <div style={priceBox}>

  {mrp > sellingPrice && (

    <div style={mrpStyle}>
      ₹{mrp}
    </div>
  )}

  <div style={priceStyle}>
    ₹{sellingPrice}
  </div>

  {mrp > sellingPrice && (

    <div style={offStyle}>
      {Math.round(((mrp - sellingPrice) / mrp) * 100)}% OFF
    </div>
  )}

</div>
              {/* CART */}
              

{qty > 0 ? (

  <div style={{ textAlign: "center" }}>

    <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>

      <button style={qtyBtn} onClick={() => decreaseQty(p.id)} disabled={isUpdating}>
        −
      </button>

      <div>{qty}</div>

      <button style={qtyBtn} onClick={() => increaseQty(p.id)} disabled={isUpdating}>
        +
      </button>

    </div>

    <button
  onClick={() => addToCart(p.id)}
  disabled={isUpdating}
  style={{
    width: "100%",
    marginTop: 10,
    background: "#0284C7",
    color: "#fff",
    padding: 8,
    borderRadius: 6,
    border: "none",
    transform: isUpdating ? "scale(0.95)" : "scale(1)",
    transition: "0.2s"
  }}
>
      {isUpdating ? <LoadingAnimation small /> : "Add More"}
    </button>

  </div>

) : (

  <button
    onClick={() => addToCart(p.id)}
    disabled={isUpdating}
    style={{
      width: "100%",
      marginTop: 10,
      background: "green",
      color: "#fff",
      padding: 10,
      borderRadius: 6,
      border: "none",
      fontWeight: 600
    }}
  >
    {isUpdating ? <LoadingAnimation small /> : "Add to Cart"}
  </button>

)}

            </div>


          );
        })}

      </div>






    </div>
  );
}



/* STYLES */

const cartBtn = {
  background: "#f59e0b",
  color: "#fff",
  border: "none",
  padding: "6px 12px",
  borderRadius: 6,
  marginRight: 10,
  cursor: "pointer"
};

const backBtn = {
  background: "#eee",
  border: "none",
  padding: "6px 12px",
  borderRadius: 6,
  cursor: "pointer"
};

	

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
  gap: 18
};

const card = {
  border: "1px solid #eee",
  padding: 14,
  borderRadius: 12,
  background: "#fff",
  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",

  minHeight: 420,   // ADD THIS
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between"
};

const nameBox = {
  textAlign: "center",
  fontWeight: 700,
  marginBottom: 8
};

const imgStyle = {
  maxHeight: "100%",
  maxWidth: "90%",
  objectFit: "contain"
};

const noImg = {
  background: "#f5f5f5",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#777"
};

const priceBox = {
  textAlign: "center",
  marginTop: 8,
  fontWeight: 700
};

const mrpStyle = {
  textDecoration: "line-through",
  color: "red",
  fontSize: 13
};

const priceStyle = {
  color: "green",
  fontSize: 17
};

const offStyle = {
  color: "orange",
  fontSize: 13
};

const addBtn = {
  width: "100%",
  marginTop: 10,
  background: "green",
  color: "#fff",
  padding: 9,
  borderRadius: 6,
  border: "none",
  fontWeight: 700,
  cursor: "pointer"
};

const qtyBox = {

  display: "flex",

  justifyContent: "center",

  alignItems: "center",

  gap: 12,

  marginTop: 12,

  width: "100%"

};

const qtyBtn = {

  width: 30,

  height: 30,

  borderRadius: 6,

  border: "none",

  background: "#2563eb",

  color: "white",

  display: "flex",

  alignItems: "center",

  justifyContent: "center",

  fontSize: 18,

  fontWeight: "bold",

  cursor: "pointer"

};




const bottomBar = {

  position: "fixed",

  bottom: 0,

  left: 0,

  right: 0,

  background: "green",

  color: "white",

  padding: "15px",
paddingBottom: "calc(15px + env(safe-area-inset-bottom))",

  

  textAlign: "center",

  fontWeight: "bold",

  cursor: "pointer",

  zIndex: 999

};
const searchBox = {

  width: "40%",        // desktop

  minWidth: "220px",   // mobile

  maxWidth: "400px",

  padding: "8px 12px",

  borderRadius: 8,

  border: "1px solid #ddd",

  fontSize: 14,

};
const searchWrapper = {

  display: "flex",

  justifyContent: "center",

  alignItems: "center",

  marginBottom: 15

};	
